/**
 * Karma is not okay with the 'import' reference, so having this in it's own
 * file allows us to add it to the 'exclude' array in 'karma.conf.js'
 * @returns new Worker(new URL('./de-id-web-worker.worker.ts', import.meta.url));
 */
export function createWorker(): Worker {
  return new Worker(new URL('./de-id-web-worker.worker', import.meta.url), { type: 'module' });
}

